module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/campaign/campaign.component.html
// module id = 959
// module chunks = 8